import { getRulebook } from '../constants/rulebooks';

export async function fetchRulebookMarkdown(rulebook) {
  if (!rulebook?.path) {
    throw new Error('Rulebook path is missing');
  }
  const base = process.env.PUBLIC_URL || '';
  const url = `${base}${rulebook.path}`;
  const response = await fetch(url);
  if (!response.ok) {
    throw new Error(`Failed to load rulebook (${response.status})`);
  }
  return response.text();
}

export async function fetchRulebookById(rulebookId) {
  const rulebook = getRulebook(rulebookId);
  if (!rulebook) {
    throw new Error('Unknown rulebook');
  }
  const markdown = await fetchRulebookMarkdown(rulebook);
  return { rulebook, markdown };
}
